import React, { Fragment, useEffect } from 'react'; // useState,
import { Form, Select } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
// todo сделать рефакторинг при просмотре карточки ТС не нужно грузить справочники, все данные есть в связках.
// справочники нужны только для редактирования.
// todo решить проблему когда просматривают карточку, и еще не выбирали бренд
const ModelName = ({
  form,
  disabled,
  modelsTypesByBrands,
  getModelsByBrand,
  brandId,
}) => {
  // modelsTypes,
  // const [brandId, setBrandId] = useState(null);
  useEffect(() => {
    if (brandId) {
      getModelsByBrand(brandId)
    }
  }, [brandId]);
  const { getFieldDecorator, getFieldValue } = form;
  const isBrand = getFieldValue('brand');
  /*const modelsByBrands =
    brandsActive && brandsActive.length !== 0
      ? modelsTypesByBrands
      : modelsTypes;*/
  const modelsByBrands = isBrand && modelsTypesByBrands;
  const onChange = val => {
    if (val && form.getFieldError('model')) {
      form.setFieldsValue({ model: val });
    }
  };
  return (
    <Fragment>
      <span className="label">Модель:</span>
      <Form.Item>
        {getFieldDecorator('model', {
          rules: [{
            required: true,
            message: "Поле, обязательно для заполнения"
          }]
        })(
          <Select
            placeholder="Выберите модель"
            className="basicInput"
            disabled={isBrand ? disabled : true}
            showSearch
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            onChange={onChange}
            getPopupContainer={trigger => trigger.parentNode}
          >
            {modelsByBrands &&
              modelsByBrands.map(type => (
                <Select.Option
                  key={type.vehicleModelId}
                  value={type.vehicleModelId}
                >
                  {type.modelName}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
    </Fragment>
  );
};

export default transportFieldsConnect(ModelName, ['modelsTypesByBrands']);
